import './ScrollableCalendar.css';
export default {
    "scrollableCalendar": "ScrollableCalendar_scrollableCalendar__dk06p",
    "scrollableList": "ScrollableCalendar_scrollableList__dk06p",
    "defaultLoadingDateCell": "ScrollableCalendar_defaultLoadingDateCell__dk06p"
};
